import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";
import { withShop } from "./web/shopfixes.js";

const StorePage = withShop(lazy(() => import("./web/StorePage.js").then((m) => ({ default: m.StorePage }))));
const EndsPage = withShop(lazy(() => import("./web/EndsPage.js").then((m) => ({ default: m.EndsPage }))));
// Head office's setup, in the Shop's settings: the planner (with the Co-op calendar reader and the settings) and the ends layout.
const PlanPage = withShop(lazy(() => import("./web/PlanPage.js").then((m) => ({ default: m.PlanPage }))));
const LayoutPage = withShop(lazy(() => import("./web/LayoutPage.js").then((m) => ({ default: m.LayoutPage }))));

export default defineWebModule({ manifest, pages: { "": StorePage, "/ends": EndsPage, "/plan": PlanPage, "/layout": LayoutPage } });
